const heading2_style = {
  // color: "#22B573",
  color: "white",
  fontSize: "calc(36px + 1vw)",
};
const heading3_style = {
  color: "#7EC0AE",
  fontSize: "calc(14px + 0.75vw)",
};
const body_text_style = {
  // fontFamily: "Roboto",
  color: "#22B573",
  fontSize: "calc(16px + 0.25vw)",
  alignText: "justify",
};

const center_div = {
  display: "grid",
  placeItems: "center",
};

export { body_text_style, heading2_style, heading3_style, center_div };
